import type { components } from "@/api/schema.ts";
import { useMutation, useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { HTTPError } from "ky";
import { api } from "@/api/ky.ts";
import { getApiUrl } from "@/api/utils.ts";

export const USER_PROFILE_KEY = "user-profile";

export type UserResponse = components["schemas"]["User"];

export function useUserQuery(options?: Omit<UseQueryOptions<UserResponse, HTTPError>, "queryFn" | "queryKey">) {
  return useQuery<UserResponse, HTTPError>({
    queryKey: [USER_PROFILE_KEY],
    queryFn: () => api.get(getApiUrl("/user-profile")).json(),
    ...options,
  });
}

type EditUserProfileInput = components["requestBodies"]["UpdatingUserProfile"]["content"]["application/json"];
type EditUserProfileResponse = components["schemas"]["User"];

export function useEditUserProfileMutation() {
  return useMutation<EditUserProfileResponse, HTTPError, EditUserProfileInput>({
    mutationFn: (json) => api.put(getApiUrl("/user-profile"), { json }).json(),
  });
}
